import { useHookstate } from "@hookstate/core";
import { Tooltip } from "@mui/material";
import { SITELOCATION_GLOBAL_STATE } from "globalStore/globalStore";
import IconDetailsIcon from "assets/svgIcons/IconDetailIcon";
import SettingDownIcon from "assets/svgIcons/SettingIcon";
import { useTranslation } from "react-i18next";

const MapSideMenu = ({ handleOpen2, handleToggle }) => {
  const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);
  const { t } = useTranslation();
  return (
    <>
      {!siteLocationGlobalData.get() ? (
        <Tooltip title={t("Map_legend")} arrow>
          <span
            className="setting-icon display"
            onClick={(e) => handleOpen2(e)}
          >
            <IconDetailsIcon color="#1d1d1d" style={{ cursor: "pointer" }} />
          </span>
        </Tooltip>
      ) : (
        ""
      )}
      {!siteLocationGlobalData.get() ? (
        <Tooltip title={t("Car_List")} arrow>
          <span className="setting-icon display" onClick={handleToggle}>
            <SettingDownIcon style={{ cursor: "pointer" }} />
          </span>
        </Tooltip>
      ) : (
        ""
      )}
    </>
  );
};

export default MapSideMenu;
